<div class="page">
	<div class="box-container">
		<app-box (buttonClick)="buttonClicked($event)" *ngFor="let element of elements" [element]="element"></app-box>
	</div>

	<img class="image" [src]="image" />
</div>
